import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology, locale } = renderModel.get();

export const logArticleView = (id: string, httpClient: HttpClientFactory) => {
  httpClient
    .getInstance()
    .get(`${clientTopology.articlesUrl}/${id}/analytics?locale=${locale}`)
    .catch((error) => {
      logger.error({
        message: `fail to log article view: ${id}`,
        error,
      });
      console.error(error);
    });
};
